var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',{model:{value:(_vm._activeTab),callback:function ($$v) {_vm._activeTab=$$v},expression:"_activeTab"}},_vm._l((_vm.tabs),function(tab){return _c('v-tab',{key:tab},[_vm._v("\n    "+_vm._s(tab)+"\n  ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }